import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './Support.module.scss';

export const SupportStepOneSection = () => (
  <AboutPageLayout
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.stepSection_1}>
          Transparen <br /> <span>Terra</span>
        </div>
        <img
          className={styles.stepSection_img}
          src="https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/sdg.svg"
          alt=""
        />
        <div className={styles.stepSection_2}>supports SDGs</div>
      </div>
    }
    rightContent={
      <div className={styles.stepContent}>
        <div>
          The 2030 Agenda for Sustainable Development, adopted by all United Nations Member States
          in 2015 as a shared blueprint for peace and prosperity for people and the planet, is
          crucial for humanity.
        </div>
        <div>
          TransparenTerra makes sustainability visible and measurable, and therefore improvable. Its
          vast network of professionals and broad range of digital tools can help define the
          bottlenecks within current economic models and find the best solutions to fix them.
        </div>
      </div>
    }
  />
);
